// https://vuex.vuejs.org/en/actions.html

import customerService from '@/services/customerService'
import store from '@/store'
import i18n from '@/i18n'

export default {
  async RefreshCustomers (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Customer.LoadingCustomers'))
    var apiResult = await customerService.getOverview()
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }
    context.commit('refreshCustomers', apiResult.value)
    // load the dependencies
    if (store.state.general.countries.length === 0) {
      await store.dispatch('RefreshCountries')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async CreateCustomer (context, customer) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Customer.CreatingCustomer'))
    var apiResult = await customerService.create(customer)
    if (apiResult.success) {
      context.commit('updateCustomer', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async UpdateCustomer (context, customer) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Customer.UpdatingCustomer'))
    var apiResult = await customerService.update(customer)
    if (apiResult.success) {
      context.commit('updateCustomer', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async ResetCustomers (context) {
    context.commit('refreshCustomers', [])
  },
  async DeleteCustomer (context, customerUid) {
    var loadingId = await store.dispatch('AddLoadingMessage', i18n.t('General.LoadMessages.Customer.DeletingCustomer'))
    var apiResult = await customerService.delete(customerUid)
    if (apiResult.success) {
      context.commit('deleteCustomer', customerUid)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
